import { EdgeTypeEnum } from '@ui/interfaces'

// import { DragEdge } from './DragEdge'
import { LogEdge } from './LogEdge'
import { MetricEdge } from './MetricEdge'
import { PlaceholderEdge } from './PlaceholderEdge'
import { SpanEdge } from './SpanEdge'

export const edgeTypes = {
  [EdgeTypeEnum.PLACEHOLDER]: PlaceholderEdge,
  // [EdgeTypeEnum.DRAG]: DragEdge,
  [EdgeTypeEnum.LOG]: LogEdge,
  [EdgeTypeEnum.SPAN]: SpanEdge,
  [EdgeTypeEnum.METRIC]: MetricEdge,
}

export default edgeTypes
